module.exports = __webpack_public_path__ + "img/zhaoshang.dae8ab0e.png";